<section id="hero" aria-labelledby="hero-heading" class="overflow-hidden">
  <div [class]="inner + ' pt-20 sm:pt-24 lg:pt-28'">
    <h1 id="hero-heading" [class]="h1">
      Access Simplified.<br />
      Credit Amplified.
    </h1>

    <div class="mt-6 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
      <p class="max-w-[50ch] text-[17px] leading-[1.6] text-cp-muted">
        Streamlined access to credit for financial advisors. Source lender terms for clients without moving the assets you manage.
      </p>
      <div class="flex flex-wrap gap-3">
        <button type="button" (click)="onRequestTerms()" [class]="btnPrimary">Request Terms</button>
        <button type="button" (click)="onExploreSolutions()" [class]="btnSecondary">Explore Solutions</button>
      </div>
    </div>

    <!-- The real portal's structure, shown large. Fades into the page like a window into the product. -->
    <figure class="mt-16 lg:mt-20">
      <div class="[mask-image:linear-gradient(to_bottom,black_72%,transparent)]">
        <app-pipeline-preview />
      </div>
      <figcaption class="mt-2 text-right text-[12px] text-cp-subtle">Sample data. Names and amounts are illustrative.</figcaption>
    </figure>
  </div>
</section>
